namespace SorAraBul.Administration {
    export interface UserCreditLogRow {
        Id?: number;
        InsertUserId?: number;
        CompanyId?: number;
        PropertyId?: number;
        TransactionType?: UserCreditTransactionType;
        Amount?: number;
        OldCredit?: number;
        NewCredit?: number;
        InsertDate?: string;
        InsertDisplayName?: string;
        PropertyPropertyName?: string;
    }

    export namespace UserCreditLogRow {
        export const idProperty = 'Id';
        export const localTextPrefix = 'Administration.UserCreditLog';
        export const deletePermission = 'Administration:SuperAdmin';
        export const insertPermission = 'Administration:SuperAdmin';
        export const readPermission = 'UserCreditLog:View';
        export const updatePermission = 'Administration:SuperAdmin';

        export declare const enum Fields {
            Id = "Id",
            InsertUserId = "InsertUserId",
            CompanyId = "CompanyId",
            PropertyId = "PropertyId",
            TransactionType = "TransactionType",
            Amount = "Amount",
            OldCredit = "OldCredit",
            NewCredit = "NewCredit",
            InsertDate = "InsertDate",
            InsertDisplayName = "InsertDisplayName",
            PropertyPropertyName = "PropertyPropertyName"
        }
    }
}
